import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from './meta-pixel';
export const CTAButton = ({
  text = 'SÍ, QUIERO ENERGÍA IMPARABLE POR $27',
  className = '',
  href
}: {
  text?: string;
  className?: string;
  href?: string;
}) => <motion.button whileHover={{
  scale: 1.02
}} whileTap={{
  scale: 0.98
}} animate={{
  boxShadow: ['0px 0px 0px rgba(255,107,0,0)', '0px 0px 25px rgba(255,107,0,0.5)', '0px 0px 0px rgba(255,107,0,0)']
}} transition={{
  repeat: Infinity,
  duration: 2.5
}} className={`w-full md:w-auto bg-gradient-to-r from-brand-orange to-brand-red text-white font-bebas text-2xl md:text-3xl py-4 px-8 md:px-12 rounded-lg shadow-lg shadow-brand-orange/20 flex items-center justify-center gap-3 uppercase tracking-wide border border-white/10 ${className}`} onClick={() => {
  if (href) {
    trackAddToCart();
    window.open(href, '_blank');
  } else {
    const target = document.getElementById('final-cta');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }
}} data-id="element-175">
    {text}
    <ArrowRight className="w-6 h-6 md:w-8 md:h-8" data-id="element-176" />
  </motion.button>;
export function useCountdown(initialHours = 4) {
  const [timeLeft, setTimeLeft] = useState(initialHours * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0')
  };
}
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6,
  delay
}} className={className} data-id="element-177">
    {children}
  </motion.div>;